import React, { useEffect } from "react";
import "./CareerPageContent.css";

const CareerPageContent = () => {
    useEffect(() => {
        // Clean up any existing widget script to allow clean initialization
        const existingScript = document.querySelector('script[src*="career-widget"]');
        if (existingScript) {
            existingScript.remove();
        }

        const script = document.createElement("script");
        script.src = "https://one.connectmarvel.com/career-widget.js";
        script.setAttribute("data-site", "cs_b6goak3ka7ve586vd4hdk8ps");
        script.async = true;
        document.body.appendChild(script);

        return () => {
            const s = document.querySelector('script[src*="career-widget"]');
            if (s) {
                s.remove();
            }
        };
    }, []);

    return (
        <div className="career-modern-page">
            {/* SECTION 1: TOP 4 PILLARS */}
            <section className="career-top-pillars-section">
                <div className="career-container">
                    <div className="career-pillars-grid">
                        <div className="career-pillar-card">
                            <h3 className="career-pillar-title">Grow your expertise</h3>
                            <p className="career-pillar-desc">
                                Build skills through meaningful, real-world work.
                            </p>
                        </div>
                        <div className="career-pillar-card">
                            <h3 className="career-pillar-title">Think with purpose</h3>
                            <p className="career-pillar-desc">
                                Bring ideas that improve products and experiences.
                            </p>
                        </div>
                        <div className="career-pillar-card">
                            <h3 className="career-pillar-title">Work as one team</h3>
                            <p className="career-pillar-desc">
                                Collaborate across teams and disciplines.
                            </p>
                        </div>
                        <div className="career-pillar-card">
                            <h3 className="career-pillar-title">Make an impact</h3>
                            <p className="career-pillar-desc">
                                Help create value for customers and partners.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* SECTION 2: REALTIME OPENINGS WIDGET */}
            <section className="career-opportunities-section" id="opportunities">
                <div className="career-container">
                    <div className="career-section-header">
                        <div className="career-header-left">
                            <span className="career-kicker">YOUR NEXT CHAPTER STARTS HERE</span>
                            <h2 className="career-main-heading">Find your opportunity.</h2>
                        </div>
                        <div className="career-header-right">
                            <p className="career-header-desc">
                                Explore current opportunities across sales and business development. Filter by location or search for a role that matches your experience.
                            </p>
                        </div>
                    </div>

                    {/* Realtime Openings Widget from internal CRM */}
                    <div className="career-widget-container">
                        <div id="marvel-careers"></div>
                    </div>
                </div>
            </section>

            {/* SECTION 3: MORE THAN A WORKPLACE */}
            <section className="career-workplace-section">
                <div className="career-container">
                    <div className="career-workplace-grid">
                        <div className="career-workplace-img-col">
                            <img
                                src="/Assets/CareerPageImages/more-than-workplace.jpg"
                                alt="Modern Marvel Lifestyle workplace"
                                className="career-workplace-img"
                                loading="lazy"
                            />
                        </div>
                        <div className="career-workplace-content-col">
                            <span className="career-kicker">MORE THAN A WORKPLACE</span>
                            <h2 className="career-workplace-heading">
                                Bring your perspective.<br />
                                Build what's next.
                            </h2>
                            <p className="career-workplace-desc">
                                At Marvel, people with different skills work together across design, manufacturing, sales and support to deliver thoughtful window-furnishing solutions. We want our people to keep learning, contribute ideas and grow with the business.
                            </p>

                            <div className="career-workplace-features">
                                <div className="career-wp-feature">
                                    <h4 className="career-wp-feature-title">Learn & develop</h4>
                                    <p className="career-wp-feature-desc">
                                        Take on challenges that help you build skills and experience.
                                    </p>
                                </div>
                                <div className="career-wp-feature">
                                    <h4 className="career-wp-feature-title">Work as one team</h4>
                                    <p className="career-wp-feature-desc">
                                        Collaborate across teams to deliver shared outcomes.
                                    </p>
                                </div>
                                <div className="career-wp-feature">
                                    <h4 className="career-wp-feature-title">Make an impact</h4>
                                    <p className="career-wp-feature-desc">
                                        Bring practical ideas and a customer-first mindset.
                                    </p>
                                </div>
                                <div className="career-wp-feature">
                                    <h4 className="career-wp-feature-title">Grow with purpose</h4>
                                    <p className="career-wp-feature-desc">
                                        Contribute to a business with an evolving global outlook.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* SECTION 4: OUR DIRECTION */}
            <section className="career-direction-section">
                <div className="career-container">
                    {/* Brand Credential Pill from Priyank Modi */}
                   {/*  <div className="career-pill-badge-container">
                        <div className="career-pill-badge">
                            <span>25+ YEARS</span>
                            <span className="career-pill-sep">•</span>
                            <span>PUBLICLY LISTED</span>
                            <span className="career-pill-sep">•</span>
                            <span>INDIA + INTERNATIONAL</span>
                            <span className="career-pill-sep">•</span>
                            <span>10X GROWTH VISION</span>
                        </div>
                    </div>  */}

                    <div className="career-direction-header">
                        <div className="career-direction-left">
                            <span className="career-kicker">OUR DIRECTION</span>
                            <h2 className="career-main-heading">Why Work With Us?</h2>
                        </div>
                        <div className="career-direction-right">
                            <p className="career-header-desc">
                                Join a company focused on quality, innovation and creating value through trusted leadership and teamwork.
                            </p>
                        </div>
                    </div>

                    <div className="career-direction-cards four-cards">
                        <div className="career-dir-card">
                            <span className="career-dir-number">01 / LEGACY & TRUST</span>
                            <h3 className="career-dir-title">25+ Years of Excellence</h3>
                            <p className="career-dir-desc">
                                Over a quarter century of pioneering innovation in the window-covering industry, building enduring trust with customers and partners.
                            </p>
                        </div>
                        <div className="career-dir-card">
                            <span className="career-dir-number">02 / GOVERNANCE</span>
                            <h3 className="career-dir-title">Publicly Listed </h3>
                            <p className="career-dir-desc">
                                A publicly listed organization operating with transparent leadership, ethical accountability, and sustainable value creation.
                            </p>
                        </div>
                        <div className="career-dir-card">
                            <span className="career-dir-number">03 / EXPANSION</span>
                            <h3 className="career-dir-title">India + International Exposure</h3>
                            <p className="career-dir-desc">
                                A commanding presence across all Indian regions, rapidly expanding into global markets with an evolving international outlook.
                            </p>
                        </div>
                        <div className="career-dir-card">
                            <span className="career-dir-number">04 / AMBITION</span>
                            <h3 className="career-dir-title">10X Growth Vision</h3>
                            <p className="career-dir-desc">
                                A relentless ambition to scale 10X, empowering teams with high-impact opportunities, ownership, and extraordinary career growth.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CareerPageContent;
